import { useQuery } from "@tanstack/react-query";
import agentsService from "services/admin/AgentsService";

export const useGetAIFunctionsDetails = (agentID, functionID) => {
    return useQuery({
        queryKey: ['getAIFunctionsDetails', agentID, functionID],
        enabled: !!agentID && !!functionID,
        queryFn: async () => {
            const { data } = await agentsService.getAIFunction(agentID, functionID)
            return data
        },
        refetchOnWindowFocus: false,
    })
}